import { MtProjectSettings } from "server/models"
import { deepCopy } from "client/utils"
import { GET, POST } from "client/store/utils"
import * as types from "./types"
import { initProjectSettings } from "./reducers"


export const LoadProjectSettings = (
    projectId: number,
): Promise<types.ProjectSettings> => (
    GET(`/mtProjectSettings/projectId/${projectId}`)
    .then((data: MtProjectSettings) => {
        const oldSettings = data && data.settings ? JSON.parse(data.settings) : {}
        const newSettings = deepCopy(initProjectSettings)

        Object.keys(newSettings).forEach((module) => {
            Object.keys(newSettings[module]).forEach((param) => {
                if (oldSettings[module] && oldSettings[module][param] !== undefined) {
                    newSettings[module][param] = oldSettings[module][param]
                }
            })
        })

        return newSettings
    })
)

export const SaveProjectSettings = (
    projectId: number,
    settings: types.ProjectSettings,
) => {
    const data: MtProjectSettings = {
        projectId,
        settings: JSON.stringify(settings),
    }
    return POST(
        "/mtProjectSettings/save",
        JSON.stringify(data),
    )
}
